<template>
  <v-dialog ref="dailyModelDialog" v-model="DailyModel.dailyModal" height="90vh" width="700px">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-form ref="form" width="100%" v-model="valid" lazy-validation>
      <v-card width="100%">
        <v-card-title>
          <v-col cols="12">
            <v-row justify="center">
              <div align="center" class="primary--text">
                <h1 v-if="!saveMode">{{ $t("newDailyModel") }}</h1>
                <h1 v-else>{{ $t("editDailyModel") }}</h1>
              </div>
            </v-row>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-layout class="ma-0 pa-0" justify-space-between row>
            <v-flex grow>
              <v-text-field
                v-model="DailyModel.dailyModelName"
                :counter="50"
                :disabled="DailyModel.locked"
                :label="$t('timemodelName')"
                :rules="dailyModelNameRules"
                required
              ></v-text-field>
            </v-flex>

            <v-flex class="ml-3" shrink>
              <v-dialog
                ref="dialog"
                v-model="DailyModel.dailyTimeModal"
                :disabled="DailyModel.locked"
                :return-value.sync="DailyModel.dailyTime"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="DailyModel.dailyTime"
                    :disabled="DailyModel.locked || !DailyModel.flexTime"
                    :label="$t('debitWorkTime')"
                    prepend-icon="mdi-clock-outline"
                    :readonly="!DailyModel.flexTime"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  color="primary"
                  v-if="DailyModel.dailyTimeModal"
                  :disabled="DailyModel.locked"
                  v-model="DailyModel.dailyTime"
                  format="24hr"
                  :readonly="!DailyModel.flexTime"
                >
                  <v-spacer></v-spacer>
                  <v-btn :disabled="DailyModel.locked" color="primary" @click="DailyModel.dailyTimeModal = false">{{ $t("cancel") }}</v-btn>
                  <v-btn :disabled="DailyModel.locked" color="primary" @click="$refs.dialog.save(DailyModel.dailyTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
          <v-switch v-model="DailyModel.flexTime" :label="$t('flexTime')"></v-switch>

          <v-layout class="mt-3 pa-0" column justify-center>
            <v-subheader class="pb-3">{{ $t("worktime") }}</v-subheader>
            <v-layout justify-space-between row>
              <v-dialog ref="startFromdialog" v-model="DailyModel.startFromTimeModal" :return-value.sync="DailyModel.startFromTime" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="DailyModel.startFromTime"
                    :disabled="DailyModel.locked"
                    :label="DailyModel.dailyTimeIsFlexible ? 'Kommen von' : $t('coming')"
                    prepend-icon="mdi-clock-outline"
                    @click:append="DailyModel.startFromTime = ''"
                    append-icon="mdi-close"
                    :rules="timeRules"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  color="primary"
                  v-if="DailyModel.startFromTimeModal"
                  v-model="DailyModel.startFromTime"
                  :disabled="DailyModel.locked"
                  format="24hr"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="DailyModel.startFromTimeModal = false">{{ $t("cancel") }}</v-btn>
                  <v-btn color="primary" @click="$refs.startFromdialog.save(DailyModel.startFromTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>

              <v-dialog
                ref="startTodialog"
                v-model="DailyModel.startToTimeModal"
                v-if="DailyModel.dailyTimeIsFlexible"
                :return-value.sync="DailyModel.startToTime"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="ma-0 pa-0"
                    :disabled="!DailyModel.dailyTimeIsFlexible"
                    v-model="DailyModel.startToTime"
                    label="Kommen bis"
                    prepend-icon="mdi-clock-outline"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  color="primary"
                  v-if="DailyModel.startToTimeModal"
                  :min="DailyModel.startFromTime"
                  v-model="DailyModel.startToTime"
                  :disabled="DailyModel.locked"
                  format="24hr"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="DailyModel.startToTimeModal = false">{{ $t("cancel") }}</v-btn>
                  <v-btn color="primary" @click="$refs.startTodialog.save(DailyModel.startToTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-layout>
            <v-layout justify-space-between row>
              <v-dialog ref="endFromdialog" v-model="DailyModel.endFromTimeModal" :return-value.sync="DailyModel.endFromTime" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="DailyModel.endFromTime"
                    :disabled="DailyModel.locked"
                    :label="DailyModel.dailyTimeIsFlexible ? 'Gehen von' : $t('going')"
                    prepend-icon="mdi-clock-outline"
                    @click:append="DailyModel.endFromTime = ''"
                    :rules="timeRules"
                    append-icon="mdi-close"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  color="primary"
                  v-if="DailyModel.endFromTimeModal"
                  v-model="DailyModel.endFromTime"
                  :disabled="DailyModel.locked"
                  :min="endFromMinTime"
                  format="24hr"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="DailyModel.endFromTimeModal = false">{{ $t("cancel") }}</v-btn>
                  <v-btn color="primary" @click="$refs.endFromdialog.save(DailyModel.endFromTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>

              <v-dialog
                ref="endTodialog"
                v-model="DailyModel.endToTimeModal"
                v-if="DailyModel.dailyTimeIsFlexible"
                :return-value.sync="DailyModel.endToTime"
                :disabled="DailyModel.locked"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="ma-0 pa-0"
                    :disabled="!DailyModel.dailyTimeIsFlexible"
                    v-model="DailyModel.endToTime"
                    label="Gehen bis"
                    prepend-icon="mdi-clock-outline"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  color="primary"
                  v-if="DailyModel.endToTimeModal"
                  :min="DailyModel.endFromTime"
                  :disabled="DailyModel.locked"
                  v-model="DailyModel.endToTime"
                  format="24hr"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="DailyModel.endToTimeModal = false">{{ $t("cancel") }}</v-btn>
                  <v-btn color="primary" @click="$refs.endTodialog.save(DailyModel.endToTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-layout>
          </v-layout>

          <v-layout class="mt-3 pa-0" column justify-center>
            <v-subheader>{{ $t("pauses") }}</v-subheader>
            <v-checkbox
              color="primary"
              class="ma-0 pa-0"
              v-model="DailyModel.fixedBreakTimes"
              :disabled="DailyModel.locked"
              :label="$t('fixedBreakTimes')"
            ></v-checkbox>

            <v-dialog
              ref="pauseDurationDialog"
              v-model="DailyModel.dailyPauses[0].pauseDurationModal"
              v-if="!DailyModel.fixedBreakTimes"
              :return-value.sync="DailyModel.dailyPauses[0].pauseDuration"
              :disabled="DailyModel.locked"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="ma-0 pa-0"
                  v-model="DailyModel.dailyPauses[0].pauseDuration"
                  :label="$t('totalBreakTime') + ' ' + $t('infoForUser')"
                  prepend-icon="mdi-clock-outline"
                  @click:append="DailyModel.dailyPauses[0].pauseDuration = ''"
                  append-icon="mdi-close"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                color="primary"
                v-if="DailyModel.dailyPauses[0].pauseDurationModal"
                v-model="DailyModel.dailyPauses[0].pauseDuration"
                format="24hr"
                :disabled="DailyModel.locked"
              >
                <v-btn color="primary" @click="DailyModel.dailyPauses[0].pauseDurationModal = false">{{ $t("cancel") }}</v-btn>
                <v-btn color="primary" @click="$refs.pauseDurationDialog.save(DailyModel.dailyPauses[0].pauseDuration)">OK</v-btn>
              </v-time-picker>
            </v-dialog>

            <v-layout class="ma-0 pa-0" v-for="(pause, id) in DailyModel.dailyPauses" :key="id" justify-space-between row>
              <v-dialog
                ref="pauseFromDialog"
                v-model="pause.pauseFromModal"
                v-if="DailyModel.fixedBreakTimes"
                :disabled="DailyModel.locked"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div style="width: 320px">
                    <v-text-field
                      class="ma-0 pa-0"
                      v-model="pause.pauseStartTime"
                      :label="$t('pause') + ' ' + pause.id + ' ' + $t('from')"
                      @click:append="pause.pauseStartTime = ''"
                      append-icon="mdi-close"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </div>
                </template>
                <v-time-picker
                  color="primary"
                  v-if="pause.pauseFromModal"
                  v-model="pause.pauseStartTime"
                  :min="DailyModel.startFromTime"
                  :max="pause.pauseEndTime"
                  :disabled="DailyModel.locked"
                  @change="timeChanged()"
                  format="24hr"
                >
                  <v-btn color="primary" @click="pause.pauseFromModal = false">{{ $t("cancel") }}</v-btn>
                  <v-btn color="primary" @click="pause.pauseFromModal = false">OK</v-btn>
                </v-time-picker>
              </v-dialog>

              <v-dialog ref="pauseToDialog" v-model="pause.pauseToModal" v-if="DailyModel.fixedBreakTimes" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <div style="width: 320px">
                    <v-text-field
                      class="ma-0 pa-0"
                      v-model="pause.pauseEndTime"
                      :label="$t('pause') + ' ' + pause.id + ' ' + $t('until')"
                      @click:append="pause.pauseEndTime = ''"
                      append-icon="mdi-close"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </div>
                </template>
                <v-time-picker
                  color="primary"
                  v-if="pause.pauseToModal"
                  v-model="pause.pauseEndTime"
                  :min="pause.pauseStartTime"
                  :max="DailyModel.endFromTime"
                  @change="timeChanged()"
                  format="24hr"
                >
                  <v-btn color="primary" @click="pause.pauseToModal = false">{{ $t("cancel") }}</v-btn>
                  <v-btn color="primary" @click="pause.pauseToModal = false">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-layout>
          </v-layout>

          <v-textarea
            name="input-7-1"
            :label="$t('remark')"
            :counter="254"
            :rules="remarkRules"
            v-model="DailyModel.dailyModelText"
            :disabled="DailyModel.locked"
            class="pb-2"
          ></v-textarea>

          <v-layout align-center justify-center>
            <v-btn v-if="!saveMode" color="primary" class="buttonHoverOpacity" @click="addTimeModel">{{ $t("addDailyModel") }}</v-btn>
            <v-btn v-else color="primary" class="buttonHoverOpacity" @click="saveTimeModel">{{ $t("saveDailyModel") }}</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  name: "DailyDialog",

  data: (vm) => ({
    //isDailyModelValid: false,
    saveMode: false,
    endFromMinTime: "",
    fixedBreakTimes: false,

    DailyModel: {
      dailyModelName: "",
      dailyModal: true,
      dailyTimeModal: false,
      dailyTime: "",
      dailyTimeIsFlexible: false,
      startFromTime: "",
      startFromTimeModal: false,
      startToTime: "",
      startToTimeModal: false,
      endFromTime: "",
      endFromTimeModal: false,
      endToTime: "",
      endToTimeModal: false,
      isPresenceOptional: false,
      dailyModelText: "",
      dailyPauses: [
        {
          id: 1,
          pauseStartTime: "",
          pauseEndTime: "",
          pauseFromModal: "",
          pauseToModal: "",
          pauseDurationModal: "",
          pauseDuration: ""
        },
        {
          id: 2,
          pauseStartTime: "",
          pauseEndTime: "",
          pauseFromModal: "",
          pauseToModal: "",
          pauseDurationModal: "",
          pauseDuration: ""
        },
        {
          id: 3,
          pauseStartTime: "",
          pauseEndTime: "",
          pauseFromModal: "",
          pauseToModal: "",
          pauseDurationModal: "",
          pauseDuration: ""
        }
      ],
      fixedBreakTimes: false,
      flexTime: false
    },

    valid: true,
    timeRules: [],
    startAndEndAtSameTime: false,
    dailyModelNameRules: [(v) => v.length < 50 || vm.$t("maximumCharacterLengthReached"), (v) => !!v || vm.$t("nameIsRequired")],
    remarkRules: [(v) => v.length <= 254 || vm.$t("maximumCharacterLengthReached")],
    pauseStartTimeRules: [],
    pauseEndTimeRules: [],
    loaderOverlay: false
  }),
  beforeDestroy: function () {
    this.$emit("close");
  },
  created: async function () {
    if (this.dailyModelId != 0) {
      await this.getDailyModel(this.dailyModelId);
    }

    if (this.DailyModel.startFromTime == "" || this.DailyModel.endFromTime == "") this.timeRules = [(v) => !!v || this.$t("timeIsRequired")];
  },
  props: {
    dailyModelId: Number
  },
  computed: {
    pause1Duration: function () {
      return this.DailyModel.dailyPauses[0].pauseDuration;
    }
  },
  watch: {
    "DailyModel.dailyModal": function (val) {
      if (!val) {
        this.$destroy();
      }
    },
    "DailyModel.dailyModelName": function (newValue, oldValue) {
      this.timeChanged();
    },
    "DailyModel.startFromTime": function (newValue, oldValue) {
      this.timeChanged();
    },
    "DailyModel.endFromTime": function (newValue, oldValue) {
      this.timeChanged();
    },
    "DailyModel.fixedBreakTimes": function (newValue, oldValue) {
      this.timeChanged();
    },

    pause1Duration: function (newValue, oldValue) {
      this.timeChanged();
    }
  },
  methods: {
    async addTimeModel() {
      if (this.$refs.form.validate() && this.checkIfPausesTimeOverlap()) {
        this.loaderOverlay = true;
        await this.$store
          .dispatch("server/timeAccounts/addDailyModel", this.DailyModel)
          .then((resp) => {
            if (resp.data.success) {
              this.$eventHub.$emit("showSuccess", this.$t("dataSendSuccessfully"));
              this.DailyModel.dailyModal = false;
            } else if (resp.data.error !== "") {
              this.$eventHub.$emit("showError", this.$t(resp.data.error));
            }
          })
          .catch((err) => {
            console.log(err);
            this.$eventHub.$emit("showError", err);
          });
        this.loaderOverlay = false;
      } else {
        if (this.DailyModel.dailyModelText.length > 254) this.$eventHub.$emit("showError", this.$t("maximumCharacterLengthReached"));
      }
    },
    async getDailyModel(dailyModelId) {
      this.loaderOverlay = true;
      await this.$store
        .dispatch("server/timeAccounts/getDayTimeModel", dailyModelId)
        .then((resp) => {
          this.processDailyModel(resp.data.data, dailyModelId);
        })
        .catch((err) => {
          console.log(err);
          this.$eventHub.$emit("showError", err);
        });
      this.loaderOverlay = false;
    },
    processDailyModel(model, id) {
      this.saveMode = true;
      this.DailyModel.id = id;
      this.DailyModel.dailyModelName = model.dailyModelName;
      if (model.startFromTime != null) this.DailyModel.startFromTime = this.$moment("2020-01-01 " + model.startFromTime).format("HH:mm");
      if (model.startToTime != null) this.DailyModel.startToTime = this.$moment("2020-01-01 " + model.startToTime).format("HH:mm");
      if (model.endFromTime != null) this.DailyModel.endFromTime = this.$moment("2020-01-01 " + model.endFromTime).format("HH:mm");
      if (model.endToTime != null) this.DailyModel.endToTime = this.$moment("2020-01-01 " + model.endToTime).format("HH:mm");
      this.DailyModel.isPresenceOptional = model.isPresenceOptional;
      this.DailyModel.fixedBreakTimes = model.isPauseFlexible;
      this.DailyModel.dailyModelText = model.dailyModelText;
      this.DailyModel.dailyTime = model.dailyTime;

      this.DailyModel.locked = model.locked;
      this.DailyModel.flexTime = model.flexTime;

      for (let i = 0; i < model.dailyPauses.length; i++) {
        if (model.dailyPauses[i].pauseStartTime != null)
          this.DailyModel.dailyPauses[i].pauseStartTime = this.$moment("2020-01-01 " + model.dailyPauses[i].pauseStartTime).format("HH:mm");
        if (model.dailyPauses[i].pauseEndTime != null)
          this.DailyModel.dailyPauses[i].pauseEndTime = this.$moment("2020-01-01 " + model.dailyPauses[i].pauseEndTime).format("HH:mm");
        if (model.dailyPauses[i].pauseDuration != null)
          this.DailyModel.dailyPauses[i].pauseDuration = this.$moment
            .utc(this.$moment.duration(model.dailyPauses[i].pauseDuration, "minutes").as("milliseconds"))
            .format("HH:mm");
      }
    },
    saveTimeModel() {
      this.loaderOverlay = true;
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("server/timeAccounts/saveDailyModel", this.DailyModel)
          .then((resp) => {
            if (resp.data.success) {
              this.$eventHub.$emit("showSuccess", this.$t("dataSendSuccessfully"));
              this.DailyModel.dailyModal = false;
            } else if (resp.data.error !== "") {
              this.$eventHub.$emit("showError", this.$t(resp.data.error));
            }
          })
          .catch((err) => {
            console.log(err);
            this.$eventHub.$emit("showError", err);
          });
      }
      this.loaderOverlay = false;
    },
    timeChanged() {
      if (this.DailyModel.startFromTime == "" || this.DailyModel.endFromTime == "") this.timeRules = [(v) => !!v || this.$t("timeIsRequired")];
      else this.timeRules = [];

      if (this.DailyModel.startFromTime == this.DailyModel.endFromTime) this.startAndEndAtSameTime = true;
      else this.startAndEndAtSameTime = false;

      if (this.DailyModel == null || this.DailyModel == undefined) {
        this.isDailyModelValid = false;
        return;
      }

      if (this.DailyModel.startFromTime != "" && this.DailyModel.endFromTime == "") this.isDailyModelValid = false;
      else if (this.DailyModel.endFromTime != "" && this.DailyModel.startFromTime == "") this.isDailyModelValid = false;
      else if (this.DailyModel.dailyModelName == undefined || this.DailyModel.dailyModelName == "") this.isDailyModelValid = false;
      else if (this.DailyModel.startFromTime == "" && this.DailyModel.endFromTime == "" && this.DailyModel.dailyPauses[0].pauseDuration != "")
        this.isDailyModelValid = false;
      else this.isDailyModelValid = true;

      if (this.DailyModel.startFromTime != "") {
        this.endFromMinTime = this.DailyModel.startFromTime;
      }

      if (this.DailyModel.startFromTime != "" && this.DailyModel.endFromTime != "") {
        var startFromTime = this.$moment.duration(this.DailyModel.startFromTime).asMinutes();

        var endFromTime = this.$moment.duration(this.DailyModel.endFromTime).asMinutes();
        let pauseDuration = 0;

        if (!this.DailyModel.fixedBreakTimes) pauseDuration = this.$moment.duration(this.DailyModel.dailyPauses[0].pauseDuration).asMinutes();
        else {
          for (let pause of this.DailyModel.dailyPauses) {
            if (pause.pauseStartTime != "" && pause.pauseEndTime != "")
              pauseDuration =
                pauseDuration + this.$moment.duration(this.$moment(pause.pauseEndTime, "HH:mm").diff(this.$moment(pause.pauseStartTime, "HH:mm"))).asMinutes();
          }
        }

        var hourDiff = (endFromTime - startFromTime - pauseDuration) / 60;

        if (this.DailyModel.dailyTime == null || this.DailyModel.dailyTime == undefined || this.DailyModel.dailyTime == "") {
          this.isDailyModelValid = true;
          this.DailyModel.dailyTime = this.$moment.utc(this.$moment.duration(hourDiff, "hours").as("milliseconds")).format("HH:mm");
        }

        if (hourDiff > 0 && !this.DailyModel.flexTime) {
          this.isDailyModelValid = true;
          this.DailyModel.dailyTime = this.$moment.utc(this.$moment.duration(hourDiff, "hours").as("milliseconds")).format("HH:mm");
        }
      }

      if (this.$moment.duration(this.DailyModel.startFromTime).asMinutes() > this.$moment.duration(this.DailyModel.endFromTime).asMinutes())
        this.isDailyModelValid = false;
    },
    checkIfPausesTimeOverlap() {
      if (!this.DailyModel.fixedBreakTimes) return true;
      else {
        let counter = 0;
        for (let pause of this.DailyModel.dailyPauses) {
          if (pause.pauseStartTime != "" && pause.pauseEndTime == "") {
            this.$eventHub.$emit("showError", this.$t("pauseEndMissing"));
            return false;
          } else if (pause.pauseStartTime == "" && pause.pauseEndTime != "") {
            this.$eventHub.$emit("showError", this.$t("pauseStartMissing"));
            return false;
          }

          ///////// Überprüft ob die Pausenzeiten nicht Start und Endzeit nicht überschreiten /////////////////////////////

          if (moment(pause.pauseStartTime, "HH:mm").isBefore(moment(this.DailyModel.startFromTime, "HH:mm"))) {
            this.$eventHub.$emit("showError", this.$t("pauseStartAndEndBeforeStart"));
            return false;
          }

          if (moment(pause.pauseStartTime, "HH:mm").isAfter(moment(this.DailyModel.endFromTime, "HH:mm"))) {
            this.$eventHub.$emit("showError", this.$t("pauseStartAndEndBeforeStart"));
            return false;
          }

          if (moment(pause.pauseEndTime, "HH:mm").isBefore(moment(this.DailyModel.startFromTime, "HH:mm"))) {
            this.$eventHub.$emit("showError", this.$t("pauseStartAndEndBeforeStart"));
            return false;
          }

          if (moment(pause.pauseEndTime, "HH:mm").isAfter(moment(this.DailyModel.endFromTime, "HH:mm"))) {
            this.$eventHub.$emit("showError", this.$t("pauseStartAndEndBeforeStart"));
            return false;
          }

          if (moment(pause.pauseEndTime, "HH:mm").isBefore(moment(pause.pauseStartTime, "HH:mm"))) {
            this.$eventHub.$emit("showError", this.$t("pauseEndBeforeStart"));
            return false;
          }

          //////// Überprüft ob die Pausen sich überschneiden //////////////////////////////////

          let pausesOverlapping = this.DailyModel.dailyPauses.some((item, index) => {
            if (
              moment(pause.pauseStartTime, "HH:mm").isBefore(moment(item.pauseEndTime, "HH:mm")) &&
              moment(pause.pauseStartTime, "HH:mm").isAfter(moment(item.pauseStartTime, "HH:mm"))
            )
              return true;
            else if (
              moment(pause.pauseEndTime, "HH:mm").isBefore(moment(item.pauseStartTime, "HH:mm")) &&
              moment(pause.pauseEndTime, "HH:mm").isAfter(moment(item.pauseStartTime, "HH:mm"))
            )
              return true;
            else if (
              moment(pause.pauseStartTime, "HH:mm").isSame(moment(item.pauseStartTime, "HH:mm")) &&
              moment(pause.pauseEndTime, "HH:mm").isSame(moment(item.pauseEndTime, "HH:mm")) &&
              counter != index
            )
              return true;
            else return false;
          });

          if (pausesOverlapping) {
            this.$eventHub.$emit("showError", this.$t("pausesOverlapError"));
            return false;
          }
          counter++;
        }

        return true;
      }
    }
  }
};
</script>

<style></style>
